export const initialState = {
  owner: null,
  businesses: [],
  selectedBusinessId: '',
  isAuthenticated: !!localStorage.getItem('session_id'),
};

export function appReducer(state, action) {
  switch (action.type) {
    case 'SET_AUTH':
      return {
        ...state,
        isAuthenticated: action.payload,
      };

    case 'SET_ME':
      return {
        ...state,
        owner: action.payload.owner || null,
        businesses: action.payload.businesses || [],
        selectedBusinessId:
          state.selectedBusinessId ||
          ((action.payload.businesses || []).length > 0
            ? action.payload.businesses[0].id
            : ''),
      };

    case 'SET_SELECTED_BUSINESS':
      return {
        ...state,
        selectedBusinessId: action.payload,
      };

    case 'LOGOUT':
      localStorage.removeItem('session_id');
      //localStorage.removeItem('user_data');

      return {
        owner: null,
        businesses: [],
        selectedBusinessId: '',
        isAuthenticated: false,
      };

    default:
      return state;
  }
}